// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-controls {
  position: absolute;
  z-index: 2;
  border-radius: 4px;
  background: #FFF;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
  max-width: 29px;
  min-width: 29px;
  min-height: 29px;
  max-height: 29px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.map-controls-icon {
  color: black;
}

.map-controls.right-top {
  margin: 10px 10px 0 0;
  right: 0;
}

.map-controls.left-top {
  margin: 10px 0 0 10px;
  top: 0;
  left: 0;
}

.map-controls.left-bottom {
  margin: 0 10px 0 10px;
  bottom: 72px;
  left: 0;
}

.map-controls.right-bottom {
  margin: 0 10px 10px 0;
  bottom: 20px;
  right: 0;
}

.map-controls-text {
  font-size: 12px !important;
  padding-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/style/boxmap/CustomMapBox.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,qBAAA;EACA,QAAA;AACJ;;AAEA;EACI,qBAAA;EACA,MAAA;EACA,OAAA;AACJ;;AAEA;EACI,qBAAA;EACA,YAAA;EACA,OAAA;AACJ;;AAEA;EACI,qBAAA;EACA,YAAA;EACA,QAAA;AACJ;;AAEA;EACI,0BAAA;EACA,iBAAA;AACJ","sourcesContent":[".map-controls {\n    position: absolute;\n    z-index: 2;\n    border-radius: 4px;\n    background: #FFF;\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);\n    max-width: 29px;\n    min-width: 29px;\n    min-height: 29px;\n    max-height: 29px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.map-controls-icon {\n    color: black;\n}\n\n.map-controls.right-top {\n    margin: 10px 10px 0 0;\n    right: 0;\n}\n\n.map-controls.left-top {\n    margin: 10px 0 0 10px;\n    top: 0;\n    left: 0;\n}\n\n.map-controls.left-bottom {\n    margin: 0 10px 0 10px;\n    bottom: 72px;\n    left: 0;\n}\n\n.map-controls.right-bottom {\n    margin: 0 10px 10px 0;\n    bottom: 20px;\n    right: 0;\n}\n\n.map-controls-text {\n    font-size: 12px !important;\n    padding-top: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
